import EditIcon from "components/Icons/EditIcon";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import DeleteIcon from "components/Icons/DeleteIcon";
import { IDriver } from "models/driver";
import { useDriverAlertContext } from "./AlertContext";
import ViewIcon from "components/Icons/ViewIcon";
import CheckIcon from "components/Icons/CheckIcon";
import BanIcon from "components/Icons/BanIcon";
import { isAdmin, isCasher } from "helpers/privilege";

interface IProps {
  driver: IDriver;
}

export default function Action({ driver }: IProps) {
  const { showDelete, showActivate, showBan } = useDriverAlertContext();

  const handleDelete = () => showDelete(driver);
  const handleClick = () => {
    if (driver.is_active) showBan(driver);
    else showActivate(driver);
  };

  return (
    <div className="flex items-center gap-x-2">
      <Link
        to={RouteName.DRIVER_DETAIL.replace(":id", driver.id)}
        className="rounded-ful hover:text-black"
      >
        <ViewIcon />
      </Link>
      {isCasher() && (
        <Link
          to={RouteName.EDIT_DRIVER.replace(":id", driver.id)}
          className="rounded-ful hover:text-black"
        >
          <EditIcon />
        </Link>
      )}
      {isAdmin() && (
        <>
          <button onClick={handleDelete} className="rounded-ful">
            <DeleteIcon />
          </button>
          <button onClick={handleClick} className="rounded-ful">
            {!driver.is_active ? <CheckIcon /> : <BanIcon />}
          </button>
        </>
      )}
    </div>
  );
}
